<template>
  <div id="mainapp" ref="mainapp">
    <div id="app">
      <CB :lang="lang" :region="region" :name="name" :birthdate="birthdate" />
    </div>
  </div>
</template>

<script>
import CB from "./components/CB.vue";
import CBBXL from "./components/CBBXL.vue";
export default {
  name: "app",
  components: {
    CB,
    CBBXL,
  },
  props: {
    region: {
      type: String,
      default: "VL",
    },
    lang: {
      type: String,
    },
    name: {
      type: String,
    },
    birthdate: {
      type: String,
    },
  },
  // created() {
  //   // this.region = window.location.pathname.split("/")[1].split("-")[1];
  //   window.parent.postMessage("hasLoaded", window.location.origin);
  // },
};
</script>

<style scoped>
:global(html) {
  /* font-size: 75%; */
  line-height: 1.15;
}
:global(body) {
  margin: 0;
}

:global(svg) {
  max-width: 1.8rem;
}

#app {
  transform: scale(0.8);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #fef0e0;
  max-width: calc(120rem + 4rem + 4rem);
  margin-left: auto;
  margin-right: auto;
}
#mainapp {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-color: #fef0e0;
  width: 100%;
  overflow: hidden;
}

@media (max-width: 48rem) {
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    background-color: #fef0e0;
    padding-bottom: 5rem;
    width: 100%;
    /*max-width: calc(120rem + 4rem + 4rem);*/
    padding-left: 0px;
    padding-left: 0rem;
    padding-right: 0px;
    padding-right: 0rem;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
